import api from '../../../services/Api';
import { IAuditoriaBeneficiosIndiretosResultado } from '../interfaces/IAuditoriaBeneficiosIndiretos';

export const AuditoriaBeneficiosIndiretosService = {
  async buscarResultado(params: {
    empresaId: number;
    periodo?: string;
  }): Promise<IAuditoriaBeneficiosIndiretosResultado> {
    const response = await api.get<IAuditoriaBeneficiosIndiretosResultado>('auditoria-beneficios-indiretos/resultado', {
      params: {
        empresaIds: params.empresaId,
        periodo: params.periodo || '',
      },
    });

    return (
      response.data || {
        impactoFiscalTotal: 0,
        impactoFinanceiroTotal: 0,
        totalAvisos: 0,
        totalAlertas: 0,
        totalErros: 0,
        status: 'CONCILIADO',
        mensagemDirecionamento: '',
        fundamentacaoBeneficioIndireto: '',
        qsaDisponivel: false,
        mensagemQsa: '',
        despesasIndevidas: [],
        proLaboreConciliado: [],
      }
    );
  },
};
